import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { QuestionManagementService } from '../../../Services/question-management/question-management.service';
import { AddQuestionModel } from 'src/app/Models/AddQuestion';
import { AddQuestionByIDModel } from 'src/app/Models/AddQuestionByID';
import { AnswerChoiceModel } from 'src/app/Models/AnswerChoiceModel';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup } from '@angular/forms';
import { VAddQuestion } from 'src/app/Validators/Validators';
// import { runInThisContext } from 'vm';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import {
  isNull,
  nullSafeIsEquivalent,
  THIS_EXPR,
} from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-question-preview',
  templateUrl: './question-preview.component.html',
  styleUrls: ['./question-preview.component.css'],
})
export class QuestionPreviewComponent implements OnInit {
  // @Input() subjectById:any;
  // @Input() selectedQuestionList:any;
  @Output() ReturnQuestionpreview: EventEmitter<any> = new EventEmitter<any>();
  @Output() AnswerNote: EventEmitter<any> = new EventEmitter<any>();

  //redirect
  @Output() EmitpreviewtoQuestion: EventEmitter<any> = new EventEmitter<any>();
  @Output() EmitpreviewtoAnswerChoice: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() EmitpreviewtoAnswerChoiceNote: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() EmitpreviewtoSolutionHint: EventEmitter<any> =
    new EventEmitter<any>();

  @Input() previewdetail: any;
  @Input() redirectscreenname: any;
  @Input() enableActions: boolean = false;

  safehtmlStr: SafeHtml;
  HTML: any;
  status: any;
  constructor(
    public dom: DomSanitizer,
    public service: QuestionManagementService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    // this.GetQuestionBodyByQuestionId(this.selectedQuestionById[0].Question_ID);
    // this.GetAnswerChoiceByQuestionID(this.selectedQuestionById.Question_Id);

    console.log(this.previewdetail, 'previewdetail');
    const safeHtml = this.previewdetail.safehtmlStr;
    this.HTML = safeHtml['changingThisBreaksApplicationSecurity'];
    this.status = this.service.QuestionByIDlist[0].Question_Status_Type_Code;
    this.Refresh();
  }

  // AnswerChoiceByQuestionid:any;
  // AnswerChoice:any;
  // GetAnswerChoiceByQuestionID(data:any){

  //   this.service.GetAnswerChoiceByQuestionID({'QuestionID':data}).subscribe((i:any)=>{
  //     this.AnswerChoice=i;
  //     this.AnswerChoiceByQuestionid=this.AnswerChoice.SubjectExistsInd;
  //     console.log(this.AnswerChoiceByQuestionid,'Answerchoice')
  //     this.AnswerChoiceByQuestionid.map((obj: { AnswerNoteflag: boolean; Answer_Choice_Id: null; Answer_Choice_Note_Body_Id: null; }) => {
  //       obj.AnswerNoteflag = false;
  //       obj.Answer_Choice_Id=null;
  //       obj.Answer_Choice_Note_Body_Id=null;
  //       return obj;
  //       })
  //    // this.AnswerChoiceInitialize(this.AnswerChoiceByQuestionid);
  //   // }).catch((e:any)=>{
  //   //   this.AnswerChoiceByQuestionid=null;
  //   // });
  // }, error => {  console.log(error) }
  // );
  // }

  // QuestionBodyByQuestionId:any;
  // Question:any;
  // QuestionBody:any;
  // GetQuestionBodyByQuestionId(data:any){

  //   this.service.GetQuestionBodyByQuestionID({'QuestionID':data}).subscribe((i:any)=>{
  //     this.Question=i;
  //     this.QuestionBodyByQuestionId=this.Question.SubjectExistsInd;
  //     this.QuestionBody=this.QuestionBodyByQuestionId[0].Question_Body_Text;
  //     this.safehtmlStr=this.dom.bypassSecurityTrustHtml(this.QuestionBody);

  // }, error => {  console.log(error) }
  // );
  // }

  // AnswerChoiceNoteList1:any;
  // AnswerChoicenote:any;
  // GetAnswerChoiceNoteByID(data:any,value:string){

  //   this.service.GetAnserChoiceNoteByID({'AnswerChoiceID':data}).subscribe((i:any)=>{
  //     this.AnswerChoicenote=i;
  //     this.AnswerChoiceNoteList1=this.AnswerChoicenote.AnswerChoiceNoteList;
  //     if(this.AnswerChoiceNoteList1.length>0){

  //   }

  // }, error => {  console.log(error) }
  // );
  // }

  Previewclose() {
    this.service.ScreenTrackName = 'app-question-preview';
    this.ReturnQuestionpreview.emit(1);
  }

  Answernote: SafeHtml="";
  AnswerChoiceNoteList: any;
  AnswerChoice: any;
  QuestionBodyget: string;
  solutionhint: SafeHtml ="";
  AnswerNotepopup(data: any) {
    if (!this.Answernote || this.Answernote == '') {
      this.service
        .GetAnserChoiceNoteByID({ AnswerChoiceID: data.Answer_Choice_ID })
        .subscribe(
          (i: any) => {
            this.AnswerChoice = i;
            this.AnswerChoiceNoteList = this.AnswerChoice.AnswerChoiceNoteList;
            if (
              this.AnswerChoiceNoteList != null &&
              this.AnswerChoiceNoteList != undefined
            ) {
              if (this.AnswerChoiceNoteList.length > 0) {
                this.AnswerChoiceNoteList.forEach(
                  (
                    currentValue: {
                      Answer_Choice_Note_Text: string;
                      Hint_Ind: any;
                    },
                    index: any
                  ) => {
                    if (currentValue.Hint_Ind == 'N') {
                      if (currentValue.Answer_Choice_Note_Text != null) {
                        this.Answernote = this.dom.bypassSecurityTrustHtml(
                          currentValue.Answer_Choice_Note_Text
                        )?? "";
                      }
                    }
                  }
                );
              }
            }
            //   if(this.AnswerChoiceNoteList!=null&&this.AnswerChoiceNoteList!=undefined){
            //     if(this.AnswerChoiceNoteList.length>0){
            //     if(this.AnswerChoiceNoteList[0].Answer_Choice_Note_Text!=null){
            //   this.Answernote=this.dom.bypassSecurityTrustHtml(this.AnswerChoiceNoteList[0].Answer_Choice_Note_Text);
            //   this.AnswerChoiceNote();
            //     }
            //   }
            // }
          },
          (error) => {
            console.log(error);
          }
        );
    }
  }

  SolutionHintpopup(data: any) {
    if (!this.solutionhint || this.solutionhint == '') {
      this.service
        .GetAnserChoiceNoteByID({ AnswerChoiceID: data.Answer_Choice_ID })
        .subscribe(
          (i: any) => {
            this.AnswerChoice = i;
            this.AnswerChoiceNoteList = this.AnswerChoice.AnswerChoiceNoteList;
            if (
              this.AnswerChoiceNoteList != null &&
              this.AnswerChoiceNoteList != undefined
            ) {
              if (this.AnswerChoiceNoteList.length > 0) {
                this.AnswerChoiceNoteList.forEach(
                  (
                    currentValue: {
                      Answer_Choice_Note_Text: string;
                      Hint_Ind: any;
                    },
                    index: any
                  ) => {
                    if (currentValue.Hint_Ind == 'Y') {
                      if (currentValue.Answer_Choice_Note_Text != null) {
                        this.solutionhint = this.dom.bypassSecurityTrustHtml(
                          currentValue.Answer_Choice_Note_Text
                        ) ?? '';
                      }
                    }
                  }
                );
              }
            }
            //   if(this.AnswerChoiceNoteList!=null&&this.AnswerChoiceNoteList!=undefined){
            //     if(this.AnswerChoiceNoteList.length>0){
            //     if(this.AnswerChoiceNoteList[0].Answer_Choice_Note_Text!=null){
            //   this.Answernote=this.dom.bypassSecurityTrustHtml(this.AnswerChoiceNoteList[0].Answer_Choice_Note_Text);
            //   this.AnswerChoiceNote();
            //     }
            //   }
            // }
          },
          (error) => {
            console.log(error);
          }
        );
    }
  }

  AnswerChoiceNotePopup: boolean;
  AnswerChoiceNote() {
    //this.GetAnswerChoiceNoteByID(this.selectedQuestionById.Answer_Choice_ID);
    this.AnswerChoiceNotePopup = !this.AnswerChoiceNotePopup;
  }

  Redirecttoquestionbody() {
    this.service.ScreenTrackName = 'app-question-preview';
    this.EmitpreviewtoQuestion.emit(1);
  }

  RedirecttoAnswerChoice() {
    this.service.ScreenTrackName = 'app-question-preview';
    this.EmitpreviewtoAnswerChoice.emit(1);
  }

  RedirecttoAnswerChoiceNote() {
    this.service.ScreenTrackName = 'app-question-preview';
    this.EmitpreviewtoAnswerChoiceNote.emit(1);
  }

  RedirecttoSolutionHint() {
    this.service.ScreenTrackName = 'app-question-preview';
    this.EmitpreviewtoSolutionHint.emit(1);
  }

  canUseEditActions(): boolean {
    const statusCode = (this.status || '').toLowerCase();
    if (statusCode === 'approved' || statusCode === 'appr') {
      return false;
    }
    return (
      this.enableActions ||
      this.status === 'WIP' ||
      this.status === 'Rework'
    );
  }

  canUseNoteActions(): boolean {
    return !!this.previewdetail?.RightAnswer11 && this.canUseEditActions();
  }

  Refresh() {
    this.Clear();

    this.getQuestionByID(this.service.QuestionByIDlist[0].Question_ID);
    this.GetAnswerChoiceByQuestionID(
      this.service.QuestionByIDlist[0].Question_ID
    );
  }
  Questionlist: any;
  getQuestionByIDlist: any;
  getQuestionByID(data: any) {
    this.service.GetQuestionByID({ QuestionID: data }).subscribe(
      (i: any) => {
        this.Questionlist = i;
        this.getQuestionByIDlist = this.Questionlist.result;
        this.service.QuestionByIDlist = this.getQuestionByIDlist;

        if (this.getQuestionByIDlist && this.getQuestionByIDlist.length > 0) {
          if (this.getQuestionByIDlist[0].Question_Status_Type_Code) {
            this.status = this.getQuestionByIDlist[0].Question_Status_Type_Code;
          }
          if (
            this.getQuestionByIDlist[0].Question_Text != null &&
            this.getQuestionByIDlist[0].Question_Text != ''
          ) {
            this.previewdetail.safehtmlStr = this.dom.bypassSecurityTrustHtml(
              this.getQuestionByIDlist[0].Question_Text
            );
          }
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }
  AnswerChoiceByQuestionid: any;
  AnswerChoice1: any;
  Answerchoiceflag: boolean = false;
  GetAnswerChoiceByQuestionID(data: any) {
    this.service.GetAnswerChoiceByQuestionID({ QuestionID: data }).subscribe(
      (i: any) => {
        this.AnswerChoice1 = i;
        this.AnswerChoiceByQuestionid = this.AnswerChoice1.SubjectExistsInd;
        this.Answerchoiceflag = true;
        console.log(this.AnswerChoiceByQuestionid, 'Answerchoice');

        this.AnswerChoiceByQuestionid.map(
          (obj: {
            SolutionHint_Answer_Choice_Note_Body_Id: null;
            SolutionHint_Answer_Choice_Id: null;
            Answer_SolutionHintflag: boolean;
            SolutionIndflag: boolean;
            AnswerNoteflag: boolean;
            Answer_Choice_Id: null;
            Answer_Choice_Note_Body_Id: null;
          }) => {
            obj.AnswerNoteflag = false;
            obj.Answer_Choice_Id = null;
            obj.Answer_Choice_Note_Body_Id = null;
            obj.Answer_SolutionHintflag = false;
            obj.SolutionHint_Answer_Choice_Id = null;
            obj.SolutionHint_Answer_Choice_Note_Body_Id = null;
            return obj;
          }
        );
        this.AnswerChoiceInitialize(this.AnswerChoiceByQuestionid);

        // }).catch((e:any)=>{
        //   this.AnswerChoiceByQuestionid=null;
        // });
      },
      (error) => {
        console.log(error);
      }
    );
  }

  AnswerChoiceNoteList1: any;
  AnswerChoicenote: any;
  GetAnswerChoiceNoteByID(data: any, value: string) {
    this.service.GetAnserChoiceNoteByID({ AnswerChoiceID: data }).subscribe(
      (i: any) => {
        let data: any = i;

        this.AnswerChoicenote = i;
        this.AnswerChoiceNoteList1 = this.AnswerChoicenote.AnswerChoiceNoteList;
        if (
          this.AnswerChoiceNoteList1 &&
          this.AnswerChoiceNoteList1.length > 0
        ) {
          this.AnswerChoiceNoteList1.forEach(
            (
              currentValue: {
                Answer_Choice_Note_Body_Id: any;
                Answer_Choice_Id: any;
                Answer_Choice_Note_Body_Text: string;
                Hint_Ind: any;
              },
              _index: any
            ) => {
              if (currentValue != null) {
                if (value == 'R') {
                  if (currentValue.Hint_Ind == 'N') {
                    this.RightAnswer1.AnswerNoteflag = true;
                    this.RightAnswer1.Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.RightAnswer1.Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                    //this.previewdetail.RightAnswer1=currentValue;

                    this.AnswerNotepopup(this.previewdetail.RightAnswer1);
                  } else {
                    this.RightAnswer1.Answer_SolutionHintflag = true;
                    this.RightAnswer1.SolutionHint_Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.RightAnswer1.SolutionHint_Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                    // this.previewdetail.RightAnswer1.Answer_Choice_ID=currentValue.Answer_Choice_Id;
                    // this.previewdetail.RightAnswer1.Answer_SolutionHintflag=true;
                    //this.previewdetail.RightAnswer1=currentValue;
                    this.SolutionHintpopup(this.previewdetail.RightAnswer1);
                  }
                } else if (value == 'W1') {
                  if (currentValue.Hint_Ind == 'N') {
                    this.WrongAnswer1.AnswerNoteflag = true;
                    this.WrongAnswer1.Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.WrongAnswer1.Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                  } else {
                    this.WrongAnswer1.Answer_SolutionHintflag = true;
                    this.WrongAnswer1.SolutionHint_Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.WrongAnswer1.SolutionHint_Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                  }
                } else if (value == 'W2') {
                  if (currentValue.Hint_Ind == 'N') {
                    this.WrongAnswer2.AnswerNoteflag = true;
                    this.WrongAnswer2.Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.WrongAnswer2.Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                  } else {
                    this.WrongAnswer2.Answer_SolutionHintflag = true;
                    this.WrongAnswer2.SolutionHint_Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.WrongAnswer2.SolutionHint_Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                  }
                } else if (value == 'W3') {
                  if (currentValue.Hint_Ind == 'N') {
                    this.WrongAnswer3.AnswerNoteflag = true;
                    this.WrongAnswer3.Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.WrongAnswer3.Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                  } else {
                    this.WrongAnswer3.Answer_SolutionHintflag = true;
                    this.WrongAnswer3.SolutionHint_Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.WrongAnswer3.SolutionHint_Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                  }
                } else if (value == 'W4') {
                  if (currentValue.Hint_Ind == 'N') {
                    this.WrongAnswer4.AnswerNoteflag = true;
                    this.WrongAnswer4.Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.WrongAnswer4.Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                  } else {
                    this.WrongAnswer4.Answer_SolutionHintflag = true;
                    this.WrongAnswer4.SolutionHint_Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.WrongAnswer4.SolutionHint_Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                  }
                } else if (value == 'W5') {
                  if (currentValue.Hint_Ind == 'N') {
                    this.WrongAnswer5.AnswerNoteflag = true;
                    this.WrongAnswer5.Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.WrongAnswer5.Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                  } else {
                    this.WrongAnswer5.Answer_SolutionHintflag = true;
                    this.WrongAnswer5.SolutionHint_Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.WrongAnswer5.SolutionHint_Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                  }
                } else if (value == 'W6') {
                  if (currentValue.Hint_Ind == 'N') {
                    this.WrongAnswer6.AnswerNoteflag = true;
                    this.WrongAnswer6.Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.WrongAnswer6.Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                  } else {
                    this.WrongAnswer6.Answer_SolutionHintflag = true;
                    this.WrongAnswer6.SolutionHint_Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.WrongAnswer6.SolutionHint_Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                  }
                } else if (value == 'W7') {
                  if (currentValue.Hint_Ind == 'N') {
                    this.WrongAnswer7.AnswerNoteflag = true;
                    this.WrongAnswer7.Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.WrongAnswer7.Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                  } else {
                    this.WrongAnswer7.Answer_SolutionHintflag = true;
                    this.WrongAnswer7.SolutionHint_Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.WrongAnswer7.SolutionHint_Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                  }
                }
              }
            }
          );
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  RightAnswer1: any;
  WrongAnswer1: any;
  WrongAnswer2: any;
  WrongAnswer3: any;
  WrongAnswer4: any;
  WrongAnswer5: any;
  WrongAnswer6: any;
  WrongAnswer7: any;
  RightAnswer11: SafeHtml;
  WrongAnswer11: SafeHtml;
  WrongAnswer22: SafeHtml;
  WrongAnswer33: SafeHtml;
  WrongAnswer44: SafeHtml;
  WrongAnswer55: SafeHtml;
  WrongAnswer66: SafeHtml;
  WrongAnswer77: SafeHtml;

  answer_choice_id: number;
  AnswerChoiceInitialize(answerchoices: any) {
    console.log(answerchoices.length);

    for (let item of answerchoices) {
      if (item.Right_Answer_Ind == 'Y') {
        this.answer_choice_id = item.Answer_Choice_ID;
        this.RightAnswer1 = item;
        this.previewdetail.RightAnswer1 = item;
        this.service.AnswerChoicelist = this.RightAnswer1;
        this.RightAnswer11 = this.dom.bypassSecurityTrustHtml(
          this.RightAnswer1.Answer_Choice_Text
        );
        this.previewdetail.RightAnswer11 = this.dom.bypassSecurityTrustHtml(
          this.RightAnswer1.Answer_Choice_Text
        );

        if (item.Answer_Choice_ID != null) {
          this.GetAnswerChoiceNoteByID(item.Answer_Choice_ID, 'R');
        }
      }
      if (item.Right_Answer_Ind == 'N') {
        if (
          this.answer_choice_id == null ||
          this.answer_choice_id == undefined
        ) {
          this.answer_choice_id = item.Answer_Choice_ID;
        }
        if (this.WrongAnswer1 == null || this.WrongAnswer1 == undefined) {
          this.answer_choice_id = item.Answer_Choice_ID;
          this.WrongAnswer1 = item;
          this.WrongAnswer11 = this.dom.bypassSecurityTrustHtml(
            this.WrongAnswer1.Answer_Choice_Text
          );
          this.previewdetail.WrongAnswer11 = this.dom.bypassSecurityTrustHtml(
            this.WrongAnswer1.Answer_Choice_Text
          );

          if (item.Answer_Choice_ID != null) {
            this.GetAnswerChoiceNoteByID(item.Answer_Choice_ID, 'W1');
          }
        } else if (
          this.WrongAnswer2 == null ||
          this.WrongAnswer2 == undefined
        ) {
          this.answer_choice_id = item.Answer_Choice_ID;
          this.WrongAnswer2 = item;
          this.WrongAnswer22 = this.dom.bypassSecurityTrustHtml(
            this.WrongAnswer2.Answer_Choice_Text
          );
          this.previewdetail.WrongAnswer22 = this.dom.bypassSecurityTrustHtml(
            this.WrongAnswer2.Answer_Choice_Text
          );
          if (item.Answer_Choice_ID != null) {
            this.GetAnswerChoiceNoteByID(item.Answer_Choice_ID, 'W2');
          }
        } else if (
          this.WrongAnswer3 == null ||
          this.WrongAnswer3 == undefined
        ) {
          this.answer_choice_id = item.Answer_Choice_ID;
          this.WrongAnswer3 = item;
          this.WrongAnswer33 = this.dom.bypassSecurityTrustHtml(
            this.WrongAnswer3.Answer_Choice_Text
          );
          this.previewdetail.WrongAnswer33 = this.dom.bypassSecurityTrustHtml(
            this.WrongAnswer3.Answer_Choice_Text
          );

          if (item.Answer_Choice_ID != null) {
            this.GetAnswerChoiceNoteByID(item.Answer_Choice_ID, 'W3');
          }
        } else if (
          this.WrongAnswer4 == null ||
          this.WrongAnswer4 == undefined
        ) {
          this.answer_choice_id = item.Answer_Choice_ID;
          this.WrongAnswer4 = item;
          this.WrongAnswer44 = this.dom.bypassSecurityTrustHtml(
            this.WrongAnswer4.Answer_Choice_Text
          );
          this.previewdetail.WrongAnswer44 = this.dom.bypassSecurityTrustHtml(
            this.WrongAnswer4.Answer_Choice_Text
          );
          if (item.Answer_Choice_ID != null) {
            this.GetAnswerChoiceNoteByID(item.Answer_Choice_ID, 'W4');
          }
        } else if (
          this.WrongAnswer5 == null ||
          this.WrongAnswer5 == undefined
        ) {
          this.answer_choice_id = item.Answer_Choice_ID;
          this.WrongAnswer5 = item;
          this.WrongAnswer55 = this.dom.bypassSecurityTrustHtml(
            this.WrongAnswer5.Answer_Choice_Text
          );
          this.previewdetail.WrongAnswer55 = this.dom.bypassSecurityTrustHtml(
            this.WrongAnswer5.Answer_Choice_Text
          );
          if (item.Answer_Choice_ID != null) {
            this.GetAnswerChoiceNoteByID(item.Answer_Choice_ID, 'W5');
          }
        } else if (
          this.WrongAnswer6 == null ||
          this.WrongAnswer6 == undefined
        ) {
          this.answer_choice_id = item.Answer_Choice_ID;
          this.WrongAnswer6 = item;
          this.WrongAnswer66 = this.dom.bypassSecurityTrustHtml(
            this.WrongAnswer6.Answer_Choice_Text
          );
          this.previewdetail.WrongAnswer66 = this.dom.bypassSecurityTrustHtml(
            this.WrongAnswer6.Answer_Choice_Text
          );
          if (item.Answer_Choice_ID != null) {
            this.GetAnswerChoiceNoteByID(item.Answer_Choice_ID, 'W6');
          }
        } else if (
          this.WrongAnswer7 == null ||
          this.WrongAnswer7 == undefined
        ) {
          this.answer_choice_id = item.Answer_Choice_ID;
          this.WrongAnswer7 = item;
          this.WrongAnswer77 = this.dom.bypassSecurityTrustHtml(
            this.WrongAnswer7.Answer_Choice_Text
          );
          this.previewdetail.WrongAnswer77 = this.dom.bypassSecurityTrustHtml(
            this.WrongAnswer7.Answer_Choice_Text
          );
          if (item.Answer_Choice_ID != null) {
            this.GetAnswerChoiceNoteByID(item.Answer_Choice_ID, 'W7');
          }
        } else {
        }
      }
      // else{
      //   this.RightAnswer1=null;
      //   this.WrongAnswer1=null;
      //   this.WrongAnswer2=null;
      //   this.WrongAnswer3=null;
      //   this.WrongAnswer4=null;
      //   this.WrongAnswer5=null;
      //   this.WrongAnswer6=null;
      //   this.WrongAnswer7=null;

      // }
    }
  }
  test: string;
  Clear() {
    this.RightAnswer1 = null;
    this.WrongAnswer1 = null;
    this.WrongAnswer2 = null;
    this.WrongAnswer3 = null;
    this.WrongAnswer4 = null;
    this.WrongAnswer5 = null;
    this.WrongAnswer6 = null;
    this.WrongAnswer7 = null;
    this.RightAnswer11 = this.test;
    this.WrongAnswer11 = this.test;
    this.WrongAnswer22 = this.test;
    this.WrongAnswer33 = this.test;
    this.WrongAnswer44 = this.test;
    this.WrongAnswer55 = this.test;
    this.WrongAnswer66 = this.test;
    this.WrongAnswer77 = this.test;

    this.previewdetail.RightAnswer1 = null;
    this.previewdetail.WrongAnswer1 = null;
    this.previewdetail.WrongAnswer2 = null;
    this.previewdetail.WrongAnswer3 = null;
    this.previewdetail.WrongAnswer4 = null;
    this.previewdetail.WrongAnswer5 = null;
    this.previewdetail.WrongAnswer6 = null;
    this.previewdetail.WrongAnswer7 = null;
    this.previewdetail.RightAnswer11 = this.test;
    this.previewdetail.WrongAnswer11 = this.test;
    this.previewdetail.WrongAnswer22 = this.test;
    this.previewdetail.WrongAnswer33 = this.test;
    this.previewdetail.WrongAnswer44 = this.test;
    this.previewdetail.WrongAnswer55 = this.test;
    this.previewdetail.WrongAnswer66 = this.test;
    this.previewdetail.WrongAnswer77 = this.test;
    this.previewdetail.previewdetail = null;
    this.previewdetail.solutionhint = '';
    this.previewdetail.Answernote = '';
  }

  dynamicTemplate = `
  <div class="row">
  <div class="col-12">
     <div class="row">
       <div class="col-12" >
       <div [innerHTML]="previewdetail.safehtmlStr">
       </div>

       </div>
     </div>
    <div>
  </div>
`;
}
